import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { DownloadButton } from './DownloadButton';
import heroVideo from '../assets/bentoMotion-logo.mp4';

export function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="sticky top-0 z-50 bg-white  border-gray-200">
      <div className="max-w-[1280px] mx-auto px-5 md:px-10 lg:px-20">
        <div className="flex items-center justify-between h-[80px] md:h-[100px]">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <video
              src={heroVideo}
              autoPlay
              loop
              muted
              playsInline
              className="h-16 w-auto md:h-20"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            
          </div>

          {/* Download Button - Desktop */}
          <div className="hidden md:block">
            <DownloadButton
              className="bg-[#FF6B6B] hover:bg-[#ff5252] text-white rounded-full px-6"
              size="default"
              showVersion={false}
            />
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 space-y-4">
            <DownloadButton
              className="bg-[#FF6B6B] hover:bg-[#ff5252] text-white rounded-full w-full"
              size="default"
              showVersion={false}
            />
          </div>
        )}
      </div>
    </nav>
  );
}

